import { Accordions } from './Accordions'
import { AddressSelect } from './Address'
import { AI_BUTTON_MENU } from './AIButton'
import {
  AITextGeneration,
  AITextGenerationFieldDraftLibrary,
  AITextGenerationFieldLibrary,
  AIVoiceInputLibrary,
} from './AITextGeneration'
import { AsyncList } from './AsyncList'
import { Avatars } from './Avatars'
import { Badges } from './Badges'
import { Breadcrumbs } from './Breadcrumbs'
import { BulletLists } from './BulletLists'
import { BUTTONS_MENU } from './Buttons'
import { CalendarGrids } from './CalendarGrids'
import { CalendarSections } from './CalendarSections'
import { CalendarSettingsForms } from './CalendarSettingsForms'
import { CalendarViews } from './CalendarViews'
import { Charts } from './Charts'
import { ChatsTableRow } from './Chats'
import { AICheckboxes, Checkboxes } from './Checkboxes'
import { CLAMPING_TEXT_MENU } from './ClampingText'
import { COLOR_PICKER_MENU } from './ColorPicker'
import { CurrencySelectUsage } from './CurrencySelect'
import { DATE_TIME_MENU } from './DateTime'
import { Deadlines } from './Deadlines'
import { DocumentsTableRow } from './Documents'
import { DocumentStaplingsTableRow } from './DocumentStaplings'
import { Dropdowns } from './Dropdowns'
import { EmailsCreationForm, EmailsRecipients, EmailsTableRow } from './Emails'
import { EntitySelects } from './EntitySelects'
import {
  EpostStatusTimelineContents,
  EpostStatusTimelineTrackingStatus,
} from './EpostStatusTimeline'
import { Files } from './Files'
import { FilesPreviewGallery } from './FilesPreviewGallery'
import { FormikFields } from './Formik'
import { HOOKS_MENU } from './hooks'
import { Icon, IconList } from './Icon'
import {
  ProfileActionsWidgetInhabitant,
  ProfileAttributesTabInhabitant,
  ProfileContractsTabInhabitant,
  ProfileCreatedWidgetInhabitant,
  ProfileEmailsTabInhabitant,
  ProfileFinancialDetailsWidgetInhabitant,
  ProfileHeaderInhabitant,
  ProfileOragClusterWidgetInhabitant,
  ProfilePartnerInfoWidgetInhabitant,
  ProfilePersonalInfoWidgetInhabitant,
  ProfilePostAddressWidgetInhabitant,
} from './InhabitantProfile'
import { InputFields } from './InputFields'
import { Labels } from './Labels'
import { Links } from './Links'
import { Modals } from './Modals'
import { MultiValuedLists } from './MultiValuedLists'
import { NavArrows } from './NavArrows'
import { Newsboard } from './Newsboard'
import { Notifications } from './Notifications'
import { PageEmptyStates } from './PageEmptyStates'
import { ProfileHeader, ProfileHeaderDocumentStapling } from './ProfileHeader'
import { RequestsPhase } from './Requests'
import { ScrollContainers } from './ScrollContainers'
import { ScrollSlider } from './ScrollSlider'
import { Selects } from './Selects'
import { Statuses } from './Statuses'
import { SubMenu } from './SubMenu'
import { Switches } from './Switches'
import { PageInput } from './Tables'
import { Tabs } from './Tabs'
import { Tags, TagUsage } from './Tags'
import { TasksTableRow, TasksTableRowComponents, TasksType } from './Tasks'
import {
  TextareasBorderless,
  TextareasInline,
  TextareasOutline,
} from './Textareas'
import { Texts } from './Texts'
import { Tooltips } from './Tooltips'
import { UploadImageUsage } from './UploadImage'
import {
  ProfileActionsWidgetUserStaff,
  ProfileFunctionalRoleModalUserStaff,
  ProfileHeaderUserStaff,
} from './UserStaffProfile'
import { WIDGETS_MENU } from './Widgets'

export const LIBRARY_MENU = [
  HOOKS_MENU,
  AI_BUTTON_MENU,
  [
    'AI Text Generation',
    [
      ['AI Text Generation Form', AITextGeneration],
      [
        'AI Text Generation Field',
        [
          ['Default', AITextGenerationFieldLibrary],
          ['Draft', AITextGenerationFieldDraftLibrary],
        ],
      ],
      ['AI Voice Input', AIVoiceInputLibrary],
    ],
  ],
  ['Accordion', Accordions],
  ['Address select', AddressSelect],
  ['Async list', AsyncList],
  ['Avatar', Avatars],
  ['Badge', Badges],
  ['Breadcrumb', Breadcrumbs],
  ['BulletList', BulletLists],
  BUTTONS_MENU,
  ['Calendar', CalendarViews],
  ['Calendar grid', CalendarGrids],
  ['Calendar section', CalendarSections],
  ['Calendar settings', CalendarSettingsForms],
  COLOR_PICKER_MENU,
  ['Chart', Charts],
  ['Chats', [['Table row', ChatsTableRow]]],
  [
    'Checkbox',
    [
      ['Default', Checkboxes],
      ['AI', AICheckboxes],
    ],
  ],
  CLAMPING_TEXT_MENU,
  ['Currency select', CurrencySelectUsage],
  DATE_TIME_MENU,
  ['Deadline', Deadlines],
  ['Documents', [['Table row', DocumentsTableRow]]],
  ['Document staplings', [['Table row', DocumentStaplingsTableRow]]],
  ['Dropdown', Dropdowns],
  [
    'Email',
    [
      ['Recipient', EmailsRecipients],
      ['Form', EmailsCreationForm],
      ['Table row', EmailsTableRow],
    ],
  ],
  ['Entity select', EntitySelects],
  [
    'EpostStatusTimeline',
    [
      ['Content', EpostStatusTimelineContents],
      ['Tracking Status', EpostStatusTimelineTrackingStatus],
    ],
  ],
  ['File', Files],
  ['Files gallery', FilesPreviewGallery],
  ['Formik fields', FormikFields],
  [
    'Icon',
    [
      ['Icon', Icon],
      ['IconList', IconList],
    ],
  ],
  [
    'Inhabitant profile',
    [
      ['Header', ProfileHeaderInhabitant],
      ['Actions widget', ProfileActionsWidgetInhabitant],
      ['Personal info widget', ProfilePersonalInfoWidgetInhabitant],
      ['Post address widget', ProfilePostAddressWidgetInhabitant],
      ['Financial details widget', ProfileFinancialDetailsWidgetInhabitant],
      ['Partner info widget', ProfilePartnerInfoWidgetInhabitant],
      ['ORAG cluster widget', ProfileOragClusterWidgetInhabitant],
      ['Created widget', ProfileCreatedWidgetInhabitant],
      ['Attributes tab', ProfileAttributesTabInhabitant],
      ['Contracts tab', ProfileContractsTabInhabitant],
      ['Email copies tab', ProfileEmailsTabInhabitant],
    ],
  ],
  ['Input', InputFields],
  ['Label', Labels],
  ['Link', Links],
  ['Modal', Modals],
  ['Multivalued list', MultiValuedLists],
  ['NavArrows', NavArrows],
  ['Newsboard', Newsboard],
  ['Notification', Notifications],
  ['Page empty state', PageEmptyStates],
  [
    'Profile',
    [
      ['Header', ProfileHeader],
      ['Header document stapling', ProfileHeaderDocumentStapling],
    ],
  ],
  ['Request phase', RequestsPhase],
  ['Scroll container', ScrollContainers],
  ['Scroll slider', ScrollSlider],
  ['Select', Selects],
  [
    'User staff profile',
    [
      ['Header', ProfileHeaderUserStaff],
      ['Actions widget', ProfileActionsWidgetUserStaff],
      ['Functional role modal', ProfileFunctionalRoleModalUserStaff],
    ],
  ],
  ['Status', Statuses],
  ['Switch', Switches],
  ['Submenu', SubMenu],
  ['Table', [['PageInput', PageInput]]],
  ['Tab', Tabs],
  [
    'Tag',
    [
      ['Showcase', Tags],
      ['Tag playground', TagUsage],
    ],
  ],
  [
    'Tasks',
    [
      ['Table row', TasksTableRow],
      ['Table row components', TasksTableRowComponents],
      ['Types', TasksType],
    ],
  ],
  [
    'Textarea',
    [
      ['Outline', TextareasOutline],
      ['Inline', TextareasInline],
      ['Borderless', TextareasBorderless],
    ],
  ],
  ['Text', Texts],
  ['Tooltip', Tooltips],
  ['Upload image', UploadImageUsage],
  WIDGETS_MENU,
]
